var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGeneralUnSelected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74.754,
    height: 83.462,
    viewBox: "0 0 74.754 83.462",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Details",
    transform: "translate(-0.012)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_890",
    "data-name": "Group 890",
    transform: "translate(0.012)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_889",
    "data-name": "Group 889"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_440",
    "data-name": "Rectangle 440",
    width: 32.631,
    height: 6.275,
    transform: "translate(23.291 38.906)",
    fill: "#625656"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M37.251,70.883H8.6a3.063,3.063,0,0,1-2.862-3.222V12.888H62.983V40.065a7.925,7.925,0,0,1,3.844-1.037,7.818,7.818,0,0,1,1.881.242V9.666C68.707,4.327,64.861,0,60.121,0H8.6C3.859,0,.012,4.327.012,9.666v58C.012,73,3.859,77.327,8.6,77.327H35.576Z",
    transform: "translate(-0.012)",
    fill: "#625656"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_441",
    "data-name": "Rectangle 441",
    width: 32.631,
    height: 6.275,
    transform: "translate(23.291 25.728)",
    fill: "#625656"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M9.012,22.444H31.875L38.351,16H9.012Z",
    transform: "translate(14.77 35.551)",
    fill: "#625656"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_442",
    "data-name": "Rectangle 442",
    width: 6.275,
    height: 6.275,
    transform: "translate(14.333 38.906)",
    fill: "#625656"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_443",
    "data-name": "Rectangle 443",
    width: 6.275,
    height: 6.275,
    transform: "translate(14.333 25.728)",
    fill: "#625656"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_444",
    "data-name": "Rectangle 444",
    width: 6.275,
    height: 6.275,
    transform: "translate(14.333 51.457)",
    fill: "#625656"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_891",
    "data-name": "Group 891",
    transform: "translate(36.873 45.417)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M35.006,20.018l-4.888-4.9a3.423,3.423,0,0,0-4.856-.029l-3.931,3.957,9.763,9.8,3.934-3.96A3.452,3.452,0,0,0,35.006,20.018Z",
    transform: "translate(1.868 -14.096)",
    fill: "#625656"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M18.08,32.405a1.39,1.39,0,0,0-.483.686L14.191,44.739a1.439,1.439,0,0,0,1.382,1.849,1.349,1.349,0,0,0,.406-.061l11.606-3.422a1.394,1.394,0,0,0,.657-.445L44.156,26.825,33.964,16.6Zm1.543,10.04-1.36-1.369,1.93-6.6L25.13,35.5l.976,5.033Z",
    transform: "translate(-14.131 -8.543)",
    fill: "#625656"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneralUnSelected);
export default __webpack_public_path__ + "static/media/General_UnSelected.4e42d18e473a439674438411509c2aab.svg";
export { ForwardRef as ReactComponent };